import InfoIcon from "@mui/icons-material/Info";
import {
  Chip,
  ChipOwnProps,
  SxProps,
  Tooltip,
  TooltipProps,
  Typography,
} from "@mui/material";

const InfoChip = ({
  sx,
  info,
  label,
  icon = <InfoIcon />,
  size = "medium",
  color = "primary",
  placement = "bottom",
}: {
  sx?: SxProps;
  size?: ChipOwnProps["size"];
  icon?: JSX.Element;
  info?: string | number;
  label?: string | JSX.Element;
  color?: ChipOwnProps["color"];
  placement?: TooltipProps["placement"];
}) => (
  <Tooltip
    title={
      <Typography fontSize={11} sx={{ whiteSpace: "pre-line" }}>
        {info}
      </Typography>
    }
    placement={placement}
    sx={sx}
  >
    {label ? (
      <Chip color={color} size={size} label={label} icon={icon} />
    ) : (
      <InfoIcon fontSize={size} sx={{ color: "inherit" }} />
    )}
  </Tooltip>
);

export default InfoChip;
